import { SearchableCampaign } from 'types/campaigns'
import { getEnumValue } from 'helpers/enumHelper'
import {
  CampaignActionRequestCampaignAction,
  CampaignAdminModelStage,
} from '@urbanx/agx.campaigns.client'
import { ActionMenu } from '@urbanx/agx.ui-components2'

interface CampaignOptionProps {
  onPerformCampaignAction(
    campaignId: string,
    campaignAction: CampaignActionRequestCampaignAction
  ): void
  selectedCampaign: SearchableCampaign
  isArchived: boolean
  dataTestId?: string
}

const CampaignOptions = (props: CampaignOptionProps) => {
  const { onPerformCampaignAction, selectedCampaign, isArchived, dataTestId } =
    props

  const actionsByStage = (campaignStage?: CampaignAdminModelStage) => {
    switch (getEnumValue(CampaignAdminModelStage, campaignStage)) {
      case CampaignAdminModelStage.AgreementDraft:
      case CampaignAdminModelStage.AgreementAgentSigning:
      case CampaignAdminModelStage.AgreementVendorSigning:
      case CampaignAdminModelStage.AgreementSignedByAllParties:
        return [
          {
            action: CampaignActionRequestCampaignAction.Archive,
            children: 'Archive',
          },
        ]
      case CampaignAdminModelStage.AgreementPendingCompliance:
        return [
          {
            action: CampaignActionRequestCampaignAction.RevertToCurrent,
            children: 'Mark as Current',
          },
        ]
      case CampaignAdminModelStage.ListingCurrent:
        return [
          {
            action: CampaignActionRequestCampaignAction.MarkAsSold,
            children: 'Mark as Sold',
          },
          {
            action: CampaignActionRequestCampaignAction.MarkAsUnderContract,
            children: 'Mark as Under Contract',
          },
          {
            action: CampaignActionRequestCampaignAction.Withdraw,
            children: 'Withdraw',
          },
        ]
      case CampaignAdminModelStage.ListingUnderContract:
        return [
          {
            action: CampaignActionRequestCampaignAction.MarkAsSold,
            children: 'Mark as Sold',
          },
          {
            action: CampaignActionRequestCampaignAction.RevertToCurrent,
            children: 'Revert to Current',
          },
        ]
      default:
        return []
    }
  }

  const actions = actionsByStage(selectedCampaign.stage)
  const visibleActions =
    !isArchived && actions.length > 0
      ? actions
      : [
          {
            action: isArchived
              ? CampaignActionRequestCampaignAction.Restore
              : CampaignActionRequestCampaignAction.Archive,
            children: isArchived
              ? CampaignActionRequestCampaignAction.Restore
              : CampaignActionRequestCampaignAction.Archive,
          },
        ]

  return (
    <ActionMenu
      actions={visibleActions}
      id={selectedCampaign.id || ''}
      onAction={(action) =>
        onPerformCampaignAction(selectedCampaign?.id || '', action)
      }
      dataTestId={dataTestId}
    />
  )
}

export default CampaignOptions
